import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../actions';

import ProbingOptions from '../containers/ProbingOptions';
import classnames from 'classnames';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const PREFIX = "OtherOptionsPane";

const classes = {
  expanded: `${PREFIX}-expanded`,
  collapsed: `${PREFIX}-collapsed`,
  extendedButton: `${PREFIX}-extendedButton`
};

const StyledDiv = styled('div')(({ theme }) => ({
  [`& .${classes.expanded}`]: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    height: "calc(100vh - 500px)",
    minHeight: 250,
    animation: "$fadeMenuIn .25s linear 1",
    overflow: "scroll",
    border: "1px solid rgba(0,0,0,.25)",
    borderRadius: "8px",
    background: "rgb(243,243,243)",
    opacity: 1
  },
  [`& .${classes.collapsed}`]: {
    opacity: 0,
    height: "0px",
    minHeight: 0,
    animation: "$fadeMenuOut .5s linear 1",
    marginTop: 0,
    padding: 0,
    overflow: "scroll",
    border: "1px solid rgba(0,0,0,.25)",
    borderRadius: "8px",
    background: "rgb(243,243,243)"
  },
  // These animations look like a simple fade in/fade out
  // but the fade out also ends the animation with height/padding/margin at 0
  // so it doesn't take up any screen real estate so mouse/pointer events
  // go through to the canvas. The height transition happens after the element
  // has already faded out completely so the user doesn't see it.
  '@keyframes fadeMenuIn': {
    from: {
      opacity: 0,
      height: "calc(100vh - 500px)",
      minHeight: 250,
      padding: theme.spacing(2),
      marginTop: theme.spacing(1)
    },
    to: {
      opacity: 1,
      minHeight: 250,
      height: "calc(100vh - 500px)",
      padding: theme.spacing(2),
      marginTop: theme.spacing(1)
    }
  },
  '@keyframes fadeMenuOut': {
    "0%": {
      opacity: 1,
      minHeight: 250,
      height: "calc(100vh - 500px)",
      padding: theme.spacing(2),
      marginTop: theme.spacing(1)
    },
    "50%": {
      opacity: 0,
      minHeight: 250,
      height: "calc(100vh - 500px)",
      padding: theme.spacing(2),
      marginTop: theme.spacing(1)
    },
    "100%": {
      opacity: 0,
      minHeight: 0,
      height: "0px",
      padding: 0,
      marginTop: 0
    }
  },
  [`& .${classes.extendedButton}`]: {
    width: "130px",
    height: "30px",
    minHeight: "30px",
    transition: "opacity .5s",
    textTransform: "none"
  },
  [`& .${classes.active}`]: {
    opacity: 1
  },
  [`& .${classes.inactive}`]: {
    opacity: .25
  }
}));

function ProbingOptionsPane(props) {
  const [ active, setActive ] = useState(false);
  const buttonActive = active;
  const expanded = useSelector((state) => state.ui.options.expanded);
  const dispatch = useDispatch();
  const handleToggleExpand = useCallback(() => {
    dispatch(actions.ui.options.toggle());
  }, [ dispatch ]);


  const handleMouseOver = useCallback(() => {
    setActive(true);
  }, [ setActive ]);

  const handleMouseOut = useCallback(() => {
    setActive(false);
  }, [ setActive ]);

  return (<StyledDiv sx={{
    position: "absolute",
    right: "20px",
    top: "211px",
    textAlign: "right",
    zIndex: 10
  }}>
    <Button variant="contained" 
            color={ "inherit"}
            className={classnames(classes.extendedButton, { [classes.active]: buttonActive, [classes.inactive]: !buttonActive })}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            onClick={handleToggleExpand}
            >{ expanded ? "Hide Options" : "Show Options" }</Button>
    <div className={ expanded ? classes.expanded : classes.collapsed }>
      <ProbingOptions/> 
    </div>
  </StyledDiv>);
}

export default ProbingOptionsPane;
